import { render } from "./Shop.vue?vue&type=template&id=e6ad56c6"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=e6ad56c6&lang=css"
script.render = render

export default script